import React from 'react'
import { GrTrash } from 'react-icons/gr'
import './DeleteRow.css'

export default function DeleteRow({showLevel, confirmer}) {

  return (
    <div className={`deleteRow ${showLevel}`} onClick={confirmer}>
      <GrTrash />
    </div>
  )
}
